import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import SpeakerSection from "./components/SpeakerSection";
import EventDetails from "./components/EventDetails";
import AgendaSection from "./components/AgendaSection";
import OrganizersSection from "./components/OrganizersSection";
import WhyAttend from "./components/WhyAttend";
import RegistrationSection from "./components/RegistrationSection";
import SponsorsSection from "./components/SponsorsSection";
import MediaPartnersSection from "./components/MediaPartnersSection";
import Footer from "./components/Footer";
import AdminPage from "./pages/AdminPage";
// V2 and V3 files are preserved but not active — routes redirect to V1

const LandingPageV1 = () => (
  <div className="hero-bg min-h-screen">
    <Navbar />
    <HeroSection />
    <SpeakerSection />
    <EventDetails />
    <AgendaSection />
    <OrganizersSection />
    <WhyAttend />
    <SponsorsSection theme="dark" />
    <MediaPartnersSection />
    <RegistrationSection />
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPageV1 />} />
          {/* V2 and V3 hidden — redirect to V1; files preserved in /pages/ */}
          <Route path="/v2" element={<Navigate to="/" replace />} />
          <Route path="/v3" element={<Navigate to="/" replace />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
